__webpack_require__.p = "/kendo-angular-ui-develop/components/";